import { CommonModule, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { RepFirm } from '../../../../models/repEditorModels'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-registration',
    templateUrl: './rep-editor-registration.component.html',
    styleUrls: ['./rep-editor-registration.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        DropDownListComponent,
        FormsModule,
        ReactiveFormsModule,
        CommandColumnComponent,
        CellTemplateDirective,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        AdminOnlyDirective
    ]
})
export class RepEditorRegistrationComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
   @Input() override repId: number = 0
  repFirm: RepFirm[]
  firmTypeList: any[]
  activeFirmTypeList = this.repState.getActiveFirmTypeList()

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repFirms) {
      this.initGrid()
    }

    if (!this.repState.firmTypeList) {
      this.typesService.getFirmTypes().subscribe((response) => {
        this.repState.firmTypeList = response
      })
    }
  }

  initGrid() {
    this.clientService
      .getRepFirmForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repFirms = response.map((rf) => new RepFirm(rf))
      })
  }

  public addHandler({ sender }) {
    const newRepFirm = new RepFirm(null)
    newRepFirm.repID = this.repId
    newRepFirm.active = true
    this.addHandlerShared({ sender }, newRepFirm)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const repFirm = new RepFirm(formGroup.value)
    this.clientService.submitRepFirmUpdate(repFirm).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new RepFirm(dataItem)
    itemToRemove.active = false
    this.clientService.submitRepFirmUpdate(itemToRemove).subscribe(() => {
      this.initGrid()
    })
  }

  public createFormGroup(repFirm: RepFirm): UntypedFormGroup {
    return this.formBuilder.group({
      repFirmID: repFirm.repFirmID,
      repID: repFirm.repID,
      firmTypeID: [repFirm.firmTypeID, Validators.required],
      firmTypeDescription: repFirm.firmTypeDescription,
      active: repFirm.active,
    })
  }
}
